import { useToggleStore } from '@/store/toggle/toggle'
import { useCityStore } from '@/store/city/city'

export default defineNuxtPlugin({
  name: 'initToggleStore',
  parallel: false,
  async setup() {
    const { cityInfo } = useCityStore()

    if (!cityInfo.domain_prefix) return

    const { getFeatureToggles } = useToggleStore()

    await getFeatureToggles()
  },
})
